/*
    t(`dictionaries.products.status.GENERATED`);
    t(`dictionaries.products.status.ISSUED`);
    t(`dictionaries.products.status.APPLIED`);
    t(`dictionaries.products.status.INTRODUCED`);
    t(`dictionaries.products.status.SOLD`);
    t(`dictionaries.products.status.DROPOUT`);
    t(`dictionaries.products.status.AGGREGATED`);
    t(`dictionaries.products.status.DISAGGREGATED`);
    t(`dictionaries.products.status.PARSED_FROM_PHOTO`);
*/
export enum ProductsStatus {
    GENERATED = 'GENERATED',
    ISSUED = 'ISSUED',
    APPLIED = 'APPLIED',
    INTRODUCED = 'INTRODUCED',
    SOLD = 'SOLD',
    DROPOUT = 'DROPOUT',
    AGGREGATED = 'AGGREGATED',
    DISAGGREGATED = 'DISAGGREGATED',
    PARSED_FROM_PHOTO = 'PARSED_FROM_PHOTO',
    ANNULLED = 'ANNULLED',
}

/*
    t(`dictionaries.products.packageType.UNIT`)
    t(`dictionaries.products.packageType.GROUP`)
    t(`dictionaries.products.packageType.PALLET`)
*/
export enum ProductsPackageType {
    BOX = 'BOX',
    BLOCK = 'BLOCK',
    PALLET = 'PALLET',
}

export enum OrderStatus {
    APPROVED = 'APPROVED',
    READY = 'READY',
    DECLINED = 'DECLINED',
    CLOSED = 'CLOSED',
}

export enum StaffRoleType {
    USER = 'USER',
    ADMIN = 'ADMIN',
}

/*
    t('dictionaries.profile.staff.status.ACTIVE')
    t('dictionaries.profile.staff.status.BLOCKED')
 */
export enum StaffUserStatus {
    ACTIVE = 'ACTIVE',
    BLOCKED = 'BLOCKED',
}

/*
    t('dictionaries.documents.status.CREATED')
    t('dictionaries.documents.status.DECLINED')
    t('dictionaries.documents.status.APPROVED')
    t('dictionaries.documents.status.PROCESSED')
*/
export enum DocumentStatus {
    NEW = 'NEW',
    SENT = 'SENT',
    REJECTED = 'REJECTED',
    ACCEPTED = 'ACCEPTED',
    CORRECTED = 'CORRECTED',
    CANCELED = 'CANCELED',
    AUTO_ACCEPTED = 'AUTO_ACCEPTED',
}

export enum DocumentProcessingStatus {
    CREATED = 'CREATED',
    APPROVED = 'APPROVED',
    DECLINED = 'DECLINED',
    NOT_ACTUAL = 'NOT_ACTUAL',
    VOID = 'VOID',
}

/*
    t('dictionaries.documents.type.AGGREGATE')
    t('dictionaries.documents.type.AGGREGATED')
    t('dictionaries.documents.type.APPLIED')
    t('dictionaries.documents.type.DROPOUT')
    t('dictionaries.documents.type.GENERATED')
    t('dictionaries.documents.type.INTRODUCE')
    t('dictionaries.documents.type.ISSUED')
    t('dictionaries.documents.type.UTILISATION')
    t('dictionaries.documents.type.DISAGGREGATED')
    t('dictionaries.documents.type.PARSED_FROM_PHOTO')
    t('dictionaries.documents.type.RETURNED')
    t('dictionaries.documents.type.UPD')
*/
export enum DocumentType {
    AGGREGATE = 'AGGREGATE',
    AGGREGATED = 'AGGREGATED',
    APPLIED = 'APPLIED',
    DROPOUT = 'DROPOUT',
    GENERATED = 'GENERATED',
    INTRODUCE = 'INTRODUCE',
    ISSUED = 'ISSUED',
    UTILISATION = 'UTILISATION',
    DISAGGREGATED = 'DISAGGREGATED',
    PARSED_FROM_PHOTO = 'PARSED_FROM_PHOTO',
    RETURNED = 'RETURNED',
    UPD = 'UPD',
    SOLD = 'SOLD',
    SALE_BY_INVOICE = 'SALE_BY_INVOICE',
    IMPORTED = 'IMPORTED',
}

export enum DocumentTypeEntity {
    AGGREGATE = 'AGGREGATE',
    DROPOUT = 'DROPOUT',
    INTRODUCE = 'INTRODUCE',
    UTILISATION = 'UTILISATION',
    UPD = 'UPD',
    MOVING = 'MOVING',
}

export enum CheckStatus {
    UNDER_APPROVAL = 'UNDER_APPROVAL',
    RETURNED = 'RETURNED',
    APPROVED_FOR_SHIPMENT = 'APPROVED_FOR_SHIPMENT',
    PENDING = 'PENDING',
    CHECK_SUCCESS = 'CHECK_SUCCESS',
    CHECK_FAIL = 'CHECK_FAIL',
    ACCEPTED = 'ACCEPTED',
    REJECTED = 'REJECTED',

    NEW = 'NEW',
    CLOSED = 'CLOSED',
    DECLINED = 'DECLINED',
    APPROVED = 'APPROVED',
    CREATED = 'CREATED',
    PROCESSED = 'PROCESSED',
}

export enum GdsStatus {
    DRAFT = 'DRAFT',
    SUBMITTED = 'SUBMITTED',
    REVIEW = 'REVIEW',
    CONFIRMED = 'CONFIRMED',
    REJECTED = 'REJECTED',
}

export enum ReceiptType {
    INCOME = 'INCOME',
    RETURN = 'RETURN',
}

export enum ReceiptStatus {
    DECLINED = 'DECLINED',
    APPROVED = 'APPROVED',
    CREATED = 'CREATED',
    PROCESSED = 'PROCESSED',
}

/*
    t('dictionaries.documents.DropOut.reasons.RETAIL')
    t('dictionaries.documents.DropOut.reasons.EEC_EXPORT')
    t('dictionaries.documents.DropOut.reasons.BEYOND_EEC_EXPORT')
    t('dictionaries.documents.DropOut.reasons.RETURN')
    t('dictionaries.documents.DropOut.reasons.REMOTE_SALE')
    t('dictionaries.documents.DropOut.reasons.DAMAGE_LOSS')
    t('dictionaries.documents.DropOut.reasons.DESTRUCTION')
    t('dictionaries.documents.DropOut.reasons.CONFISCATION')
    t('dictionaries.documents.DropOut.reasons.LIQUIDATION')
    t('dictionaries.documents.DropOut.reasons.DONATION')
    t('dictionaries.documents.DropOut.reasons.STATE_ENTERPRISE')
    t('dictionaries.documents.DropOut.reasons.ENTERPRISE_USE')
    t('dictionaries.documents.DropOut.reasons.NO_RETAIL_USE')
    t('dictionaries.documents.DropOut.reasons.RETAIL_RETURN')
    t('dictionaries.documents.DropOut.reasons.REMOTE_SALE_RETURN')
    t('dictionaries.documents.DropOut.reasons.INSTALMENT')
*/
export enum DropOutReasons {
    RETAIL = 'RETAIL',
    EEC_EXPORT = 'EEC_EXPORT',
    BEYOND_EEC_EXPORT = 'BEYOND_EEC_EXPORT',
    RETURN = 'RETURN',
    REMOTE_SALE = 'REMOTE_SALE',
    DAMAGE_LOSS = 'DAMAGE_LOSS',
    DESTRUCTION = 'DESTRUCTION',
    CONFISCATION = 'CONFISCATION',
    LIQUIDATION = 'LIQUIDATION',
    DONATION = 'DONATION',
    STATE_ENTERPRISE = 'STATE_ENTERPRISE',
    ENTERPRISE_USE = 'ENTERPRISE_USE',
    NO_RETAIL_USE = 'NO_RETAIL_USE',
    RETAIL_RETURN = 'RETAIL_RETURN',
    REMOTE_SALE_RETURN = 'REMOTE_SALE_RETURN',
    INSTALMENT = 'INSTALMENT',
}

export enum AuthenticStatus {
    'AUTHENTIC' = 'AUTHENTIC',
    'COUNTERFEIT' = 'COUNTERFEIT',
    // 'DUBIOUS' = 'DUBIOUS',
}

export enum AuthenticDetectionContext {
    RETAIL_SALES = 'RETAIL_SALES',
    MANUAL = 'MANUAL',
}
